var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.src)?_c('nuxt-img',{attrs:{"src":_vm.src,"alt":_vm.altText || 'Card image',"width":_vm.parsedSize.width,"height":_vm.parsedSize.height,"preset":"card-image","provider":"shopify"}}):_vm._e(),_vm._v(" "),_vm._t("discount-pill"),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }